import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
export const NAMESPACE = "table";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export { PARENT_NAMESPACE as PAGE_NAMESPACE };
export const localStorageSettingsKey = "ohotnik.gridView.settings";
